<template>
  <b-button @click="logout" :disabled="loading" :loading="loading">{{
    $t("navigation.logout")
  }}</b-button>
</template>

<script>
import firebase from "firebase/app";
import toast from "@/mixins/toast";

export default {
  mixins: [toast],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    logout() {
      this.loading = true;
      firebase
        .auth()
        .signOut()
        .then(
          () => {
            this.loading = false;
            this.$store.dispatch("authentication/clearAuthenticatedUser");
            this.$store.commit("categories/resetCategories", []);
            this.$store.commit("transactions/resetTransactions", []);
            this.$store.commit("transactions/setCurrentMonth", null);

            this.showValidLogout();
            this.$router.push("login");
          },
          (error) => {
            this.loading = false;
            this.showInvalidLogout(error);
          }
        );
    },
    showValidLogout() {
      this.showSuccessToast(this.$t("notifications.successLogout"));
    },
    showInvalidLogout(msg) {
      this.showErrorToast(msg || this.$t("notifications.errorLogout"));
    },
  },
};
</script>
